import React, { ReactText } from 'react';
import { JiraIcon } from '@atlaskit/logo';
import { css } from '@emotion/core';
import { token } from '@atlaskit/tokens';

import { colors, SPACE_COMPACT, flexStart } from '@/styles';

interface IProps {
  ticket: ReactText;
  href?: string;
}

const styles = [
  flexStart,
  css`
    width: max-content;
    padding-right: ${SPACE_COMPACT}px;
  `,
];

const Ticket: React.FC<IProps> = ({ ticket, href }) => {
  const children = (
    <>
      <JiraIcon
        iconGradientStart={token('color.background.selected', colors.B400)}
        iconColor={token('color.background.brand.bold', colors.B200)}
        iconGradientStop={token('color.background.brand.bold', colors.B200)}
        size="small"
        css={css`
          margin-right: 8px;
        `}
      />{' '}
      {ticket}
    </>
  );
  return href ? (
    <a href={href} css={styles} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  ) : (
    <p css={styles}>{children}</p>
  );
};

export default Ticket;
